import { AxiosRequestConfig } from "axios";
import { FilteredListDto } from "../base/base.dto";
import http from "../base/http.service";
import {
  AuditQuestionDto,
  CreateAuditQuestionDto,
  UpdateAuditQuestionDto,
} from "./audit-questions.dto";

const services = {
  GetAll(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<FilteredListDto<AuditQuestionDto>>("AuditQuestions", config);
  },
  Get(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<AuditQuestionDto>(`AuditQuestions/${id}`, config);
  },
  Add(dto: CreateAuditQuestionDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<AuditQuestionDto>("AuditQuestions", dto, config);
  },
  Delete(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.remove<AuditQuestionDto>(`AuditQuestions/${id}`, config);
  },
  Update(dto: UpdateAuditQuestionDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<AuditQuestionDto>("AuditQuestions", dto, config);
  },
};

export default services;
